<template>
  <div>
    <el-form
      v-if="!disabled"
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <div>
        <div class="title">{{ $l('form_label_warehouse') || '客户仓库' }}</div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_warehouse_and_name') || '仓库编号或名称'"
              prop="whName"
            >
              <el-input
                v-model="formData.whName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="100"
                size="mini"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_RegionName_wh') || '所在地区'"
              prop="whRegionName"
            >
              <el-input
                v-model="formData.whRegionName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                size="mini"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_transitTimes') || '运输周期'"
              prop="transitTimes"
            >
              <el-input-number
                v-model="formData.transitTimes"
                v-el-inputnumber-default0
                :controls="false"
                style="width: 100%"
                :precision="0"
                :min="0"
                :max="9999"
                size="mini"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_shippingTimes') || '发运周期'"
              prop="shippingTimes"
            >
              <el-input-number
                v-model="formData.shippingTimes"
                v-el-inputnumber-default0
                :controls="false"
                style="width: 100%"
                :precision="0"
                :min="0"
                :max="9999"
                size="mini"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <ItemTable
            ref="itemTable"
            :disabled="disabled"
            :evgPlanOrderCode="evgPlanOrderCode"
            :transitTimes="formData.transitTimes"
            :shippingTimes="formData.shippingTimes"
          />
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
export default {
  mixins: [EditLoading],
  components: { ItemTable },
  props: {
    disabled: { type: Boolean, default: false },
    evgPlanOrderCode: { type: String, default: '' },
    evgPlanOrderWhCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        transitTimes: 0,
        shippingTimes: 0,
      },
      rules: {
        whName: [
          {
            trigger: 'blur',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        whRegionName: [
          {
            trigger: 'blur',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        transitTimes: [
          {
            trigger: 'blur',
            required: true,
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_transitTimes_must_be_greater_than_0') ||
              '运输周期须大于0',
          },
        ],
        shippingTimes: [
          {
            trigger: 'blur',
            required: true,
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_shippingTimes_must_be_greater_than_0') ||
              '发运周期须大于0',
          },
        ],
      },
    }
  },
  computed: {},
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.evgPlanOrderWhCode) return
      const res = await this.$api
        .ecomEvgPackingSchemeWhDetailApi({
          evgPlanOrderWhCode: this.evgPlanOrderWhCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
      this.$refs.itemTable.loadData(this.formData.planOrderDetailList)
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const detailsResult = await this.$refs.itemTable.validate()
      return formResult && detailsResult
    },
    async save() {
      if (!(await this.formValidate())) return
      const listItem = this.$refs.itemTable.getTableData()
      if (!listItem || !listItem.length) {
        this.$message.warning(
          this.$l('form_label_ple_plan_detail') || '请添加计划明细'
        )
        return
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgPackingSchemeWhSaveApi({
          ...this.formData,
          planOrderDetailList: listItem,
          evgPlanOrderCode: this.evgPlanOrderCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  color: #101010;
  font-weight: 600;
  margin-bottom: 5px;
}
</style>
